'use client'
import React, { useEffect, useRef, useState } from "react";
import { Popover, Segmented, Modal, Checkbox } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { useGlobalContext } from "../../context/provider";
import { AxiosGetData, AxiosPostData, AxiosDeleteData, AxiosPutData } from "../../context/axiosfunction";
import Link from "next/link";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import "dayjs/locale/th";
dayjs.locale("th");


const NotiDesktop = ({ noti }) => {
  const { theme, API, headers, privateKey, Noti_length, setNoti } = useGlobalContext();
  const [Noti, setNotidata] = useState([]);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [onSelectSave, setOnSelectSave] = useState([])
  const [save, setSave] = useState(false)
  const [deletemodal, setDelete] = useState(false)
  const [notitype, setNotiType] = useState('feed')
  const [notitypedata, setnotitypedata] = useState([])
  const scrollContainerRef = useRef(null);
  const sentinelRef = useRef(null);

  // ✅ โหลดหน้าแรกเมื่อเปิด Popover
  useEffect(() => {
    if (!open) return;
    const fetchFirstPage = async () => {
      setIsLoading(true);
      try {
        const data = await AxiosGetData(API, `/api/checkauthent/get_usernoti?page=1`, headers, privateKey);
        if (Array.isArray(data)) {
          setNotidata(data);
          setHasMore(data.length >= 50);
          setPage(1);
        } else {
          setNotidata([]);
          setHasMore(false);
        }
      } finally {
        setIsLoading(false);
        localStorage.setItem('Noti', 0)
        setNoti(0)
      }
    };
    fetchFirstPage();
  }, [open]);

  // ✅ โหลดหน้าถัดไป
  const loadNextPage = async () => {
    if (isLoading || !hasMore) return;
    setIsLoading(true);
    try {
      const nextPage = page + 1;
      const newData = await AxiosGetData(
        API,
        `/api/checkauthent/get_usernoti?page=${nextPage}`,
        headers,
        privateKey
      );
      if (!Array.isArray(newData) || newData.length === 0) {
        setHasMore(false);
        return;
      }
      setNotidata(prev => {
        const ids = new Set(prev.map(i => i.id));
        const merged = [...prev, ...newData.filter(i => !ids.has(i.id))];
        return merged;
      });
      setPage(nextPage);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ IntersectionObserver ที่ชี้ root เป็น scroll container
  useEffect(() => {
    if (!open || !scrollContainerRef.current || !sentinelRef.current) return;

    const observer = new IntersectionObserver(
      entries => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          loadNextPage();
        }
      },
      {
        root: scrollContainerRef.current,
        rootMargin: "80px",
        threshold: 0.1,
      }
    );

    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [open, Noti, page, hasMore, isLoading]);


  const OnDelete = async () => {
    try {
      const deletenoti = await AxiosDeleteData(API, 'checkauthent/delete_noti', DataUser.uid, headers)

      if (deletenoti.status === 'success') {
        messageAPI.open({
          type: 'success',
          content: 'ลบแจ้งเตือนทั้งหมดแล้ว'
        })

        return setTimeout(() => {
          window.location.reload()
        }, 500)
      }
    } catch (error) {

    }
  }

  const OnSelectSave = (id) => {
    setOnSelectSave((prev) => {
      if (prev.includes(id)) {
        // ถ้ามีอยู่แล้ว → ลบออก
        return prev.filter((x) => x !== id);
      } else {
        // ถ้ายังไม่มี → เพิ่มเข้าไป
        return [...prev, id];
      }
    });
  };

  useEffect(() => {
    if (notitype === 'feed') {
      const filterfeed = Noti.filter(data => data.noti.type !== 'SYSTEM')
      setnotitypedata(filterfeed)
    } else if (notitype === 'system') {
      const filterSystem = Noti.filter(data => data.noti.type === 'SYSTEM')
      setnotitypedata(filterSystem)
    } else if (notitype === 'keep') {
      const filterKeep = Noti.filter(data => data.archived === 1)
      setnotitypedata(filterKeep)
    }

  }, [Noti, notitype])

  const SaveNoti = async () => {
    const noti_id = { noti_id: onSelectSave }

    try {
      const response = await AxiosPutData(API, '/api/checkauthent/save_noti', noti_id, headers)
      if (response.status === 'success') {
        setNotidata((prev) =>
          prev.map((item) =>
            onSelectSave.includes(item.id)
              ? { ...item, archived: 1 }
              : item
          )
        );
        setSave(false)
      }

    } catch (error) {

    }
  }

  return (
    <div className="text-primary">
      <Modal zIndex={2000} title="ลบแจ้งเตือน" open={deletemodal} onCancel={() => setDelete(false)} onOk={() => OnDelete()}>
        <div>ต้องการลบแจ้งเตือนทั้งหมดในไอดีใช่หรือไม่</div>
      </Modal>
      <Popover
        open={open}
        overlayStyle={{ zIndex: 900 }}
        onOpenChange={(e) => { setOpen(e); setSave(false); setOnSelectSave([]); setNotiType('feed') }}
        trigger="click"
        overlayClassName="custom-noti-popover"
        content={
          <div>
            <div className="flex justify-between w-full  ">
              <Segmented
                className="page-surface noti-seg text-primary px-5 rounded-none"
                onChange={(value) => setNotiType(value)}
                options={[
                  { label: 'แจ้งเตือน', value: 'feed' },
                  { label: 'ฟีตข่าว', value: 'system' },
                  { label: 'ที่จัดเก็บ', value: 'keep' },
                ]}
              />
              <span className="flex gap-[10px]">

                {save ?
                  <button onClick={() => SaveNoti()} className="cursor-pointer">
                    <FontAwesomeIcon className="text-[rgb(8,131,28)]" icon={faFloppyDisk} size="xl" />
                  </button>
                  :
                  <button onClick={() => setSave(true)} className="cursor-pointer">
                    <FontAwesomeIcon className="text-[rgb(8,131,28)]" icon={faDownload} size="xl" />
                  </button>
                }
                <button onClick={() => setDelete(true)} className="cursor-pointer"><FontAwesomeIcon className="text-[#d32424]" icon={faTrashCan} size="lg" /></button>
              </span>
            </div>

            <div
              ref={scrollContainerRef}
              style={{ width: 320, minHeight: 400, maxHeight: 400, overflowY: "auto" }}
              className="scroll-container"
            >
              {notitypedata.length > 0 ?
                <>
                  {notitypedata.map((data, i) => {
                    const parsed = (() => {
                      try { return JSON.parse(data.noti.data || "{}"); } catch { return {}; }
                    })();
                    if (save) {
                      return (
                        <Checkbox key={i} onChange={() => OnSelectSave(data.id)}>
                          <div
                            className="block text-primary px-3 min-h-[80px] hover:bg-gray-50"
                          >
                            <div className="grid grid-cols-12 items-center py-2">
                              <div className="col-span-2">
                                {parsed.image && <img src={parsed.image} alt="img" className="w-full h-auto object-cover" />}
                              </div>
                              <div className="col-span-10 pl-2">
                                <div className={`${!data.is_read && 'font-bold'} line-clamp-2`}>{data.noti.title}</div>
                                <div className="text-[12px] mx-2 line-clamp-2">{data.noti.body}</div>
                              </div>
                            </div>
                          </div>
                        </Checkbox>
                      );
                    } else {
                      return (
                        <Link
                          href={parsed.link || "#"}
                          key={i}
                          onClick={() => AxiosPostData(API, '/api/checkauthent/click_noti', { id: data.id }, headers)}
                          passHref
                          className="block text-primary px-3 min-h-[80px] hover:bg-gray-50"
                        >
                          <div className="grid grid-cols-12 items-center py-2">
                            <div className="col-span-2">
                              {parsed.image && <img src={parsed.image} alt="noti_img" className="w-full rounded-sm h-auto object-cover" />}
                            </div>
                            <div className="col-span-10 pl-2">
                              <div className={`${!data.is_read && 'font-bold'} line-clamp-2`}>{data.noti.title}</div>
                              <div className="text-[12px] mx-2 line-clamp-2">{data.noti.body}</div>
                              <div className="text-[12px] mx-1 ">{dayjs(data.noti.delivered_at).format('D MMM YYYY HH:mm น.')}</div>
                            </div>
                          </div>
                        </Link>
                      )
                    }

                  })}

                  <div ref={sentinelRef} style={{ height: "1px" }} />
                  {isLoading && <div className="text-center p-2 text-gray-500">กำลังโหลด...</div>}
                  {/* {!hasMore && <div className="text-center text-gray-400 p-2">หมดแล้ว</div>} */}
                </>
                :
                <>
                  <div className="flex flex-col items-center justify-center gap-[1em] my-6">
                    <img src="https://eve-image.eveebook.com/image.eveebook/mascot/shock.png" alt="nonnoti" />
                    <div className="text-base my-3 text-primary">{(notitype === 'feed' || notitype === 'system') ? 'ไม่พบแจ้งเตือน' : 'ไม่มีแจ้งเตือนที่บันทึกไว้'}</div>
                  </div>
                </>
              }

            </div>
          </div>
        }
      >
        <button
          type="button"
          className="page-surface cursor-pointer w-[35px] sm:w-[48px] h-[35px] sm:h-[48px] rounded-full flex flex-col relative justify-center items-center"
          aria-label="notifications"
        >
          {(Noti_length > 0 || noti > 0) && (
            <div className="absolute top-0 right-0 bg-[#e04c4c] text-white rounded-full text-[10px] flex justify-center items-center w-[17px] h-[17px]">
              {Noti_length}
            </div>
          )}
          <img
            className="w-auto h-[24px]"
            src={
              theme === "dark_theme"
                ? "https://eve-image.eveebook.com/image.eveebook/web_image/noti_w.png"
                : "https://eve-image.eveebook.com/image.eveebook/web_image/noti_b.png"
            }
            alt="noti"
          />
        </button>
      </Popover>
    </div>
  );
};

export default NotiDesktop;
